export default __webpack_public_path__ + "static/media/productHealthCheckPackage1_all_Hk.7dc4721b.webp";